import { CampaignControllerAction } from "./CampaignControllerAction";
export const isCampaignControllerActionCreative = (action) => {
    return action.action_type === "CREATIVE";
};
export class CampaignControllerActionCreative extends CampaignControllerAction {
    constructor(response, context) {
        super(response, context);
        this.action_id = response.action_id;
        this.action_type = response.action_type;
        this.quality = response.quality;
        this.enabled = response.enabled;
        this.component_ids = response.component_ids;
        this.classification = response.classification;
        this.api_version = response.api_version;
        this.theme_version = response.theme_version;
    }
}
